import "core-js/stable";
import "core-js/features/array/find";
import "core-js/features/array/includes";
import "core-js/features/number/is-nan";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import "moment/locale/tr";

import { library } from "@fortawesome/fontawesome-svg-core";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";

import API from "API";
import { notification, message } from "antd";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, useHistory } from "react-router-dom";
import {
  createStore,
  StoreProvider,
  useStoreActions,
  useStoreRehydrated,
  useStoreState,
  createComponentStore,
} from "easy-peasy";

import Store, { ConfigureStore } from "Store";
import AppStoreModel from "Store/models/app";

import * as serviceWorker from "./serviceWorker";

import "Styles/app.less";
import AppLoading from "Components/app-loading";
import AppRoutes from "Routes";
import ErrorHandler from "Components/error-handler";
import moment from "moment";

library.add(far, fas);

const GeneralStore = createStore(Store, ConfigureStore);

const App = () => {
  let history = useHistory();
  const rehydrated = useStoreRehydrated();

  const { loading } = useStoreState((store) => store.app);
  const { setLoading } = useStoreActions((store) => store.app);

  const { authToken, refreshToken, isAuthenticated } = useStoreState(
    (store) => store.auth
  );

  const {
    setAuthenticated,
    setAuthToken,
    setRefreshToken,
    setUser,
    getCurrentUser,
  } = useStoreActions((store) => store.auth);

  const RuleStoreActions = useStoreActions((store) => store.rules);

  const { setMessage } = useStoreActions((store) => store.error);

  async function setAuth(config) {
    return new Promise(async (resolve, reject) => {
      if (authToken) {
        config.defaults.headers["Authorization"] = `Bearer ${authToken}`;
        await setAuthenticated(true);
        resolve(true);
      } else {
        delete config.defaults.headers["Authorization"];
        await setAuthenticated(false);
        resolve(false);
      }
    });
  }

  useEffect(() => {
    async function setGlobalErrorHandler() {
      await API.SetGlobalErrorHandler(async (error) => {
        if (error?.data?.errors && error?.data?.errors.length > 0)
          setMessage(error.data.errors.join(","));
        else if (error?.message)
          switch (error.message) {
            case "Network Error":
              setMessage(
                "Bağlantı Hatası. Sunucularımıza erişiminizde problem yaşanıyor." +
                  "Lütfen internet bağlantınızı kontrol edin. Sorun devam ederse müşteri temsilcimize danışın."
              );
              break;
            default:
              setMessage(error.message);
          }
        else setMessage("Beklenmedik bir hata oluştu.");
      });
    }

    setGlobalErrorHandler();
  }, []);

  useEffect(() => {
    async function setAppAuthCatcher() {
      setLoading(true);
      await API.SetAuthCatcher(async (config) => await setAuth(config));
      setLoading(false);
    }
    setAppAuthCatcher();
  }, [authToken]);

  useEffect(() => {
    API.SetRefreshLogic(async () => {
      try {
        await API.post("auth/refreshToken", {
          refresh_token: refreshToken,
        }).then((response) => {
          setAuthToken(response.accessToken);
        });
      } catch (error) {
        setAuthToken(null);
        setRefreshToken(null);
        setUser(null);
        setAuthenticated(false);

        history.push("/login");
        notification.warning({
          message: "Oturumunuz yenilemedi.",
          description: "Güvenliğiniz için tekrar giriş yapmalısınız.",
        });
      }
    });
  }, [refreshToken]);

  useEffect(() => {
    if (isAuthenticated) {
      getCurrentUser();
      RuleStoreActions.fetch();
    }
  }, [isAuthenticated]);

  return rehydrated && !loading ? <AppRoutes /> : <AppLoading />;
};

ReactDOM.render(
  <StoreProvider store={GeneralStore}>
    <ErrorHandler />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StoreProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
